import Wallet from './template_01';

const DefaultWallet=(props) =>{
    return (
        <Wallet {...props}/>
    );
  }
  
  export default DefaultWallet;